import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { CheckCircleOutlined, CloseFilledOutlined, UploadFileOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

import { Button } from "@/components/common/Button"
import { FILE_UPLOAD_TAKES_TIME_MESSAGE } from "@/components/upload/constants"

const AddMoreFilesModal: FC<{
  onSubmit: () => void
  onClose: () => void
}> = ({ onSubmit, onClose }) => {
  return (
    <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box display='flex' justifyContent='flex-end'>
          <Button size='small' appearance='text' onClick={onClose}>
            <CloseFilledOutlined className='text-blue-gray' />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box textAlign='center'>
          <CheckCircleOutlined className='size-[48px] text-green-500' />
          <Typography variant='h5' color='primary' className='mt-6 font-normal'>
            File Successfully Uploaded
          </Typography>

          <Typography className='mt-6 px-3 text-base leading-[150%] tracking-[-0.85px] text-gray-700'>
            Please “Continue” to view your uploaded files or “Upload Another File”.
            <br />
            {FILE_UPLOAD_TAKES_TIME_MESSAGE}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display='flex' justifyContent='center' width='100%' p={2}>
          <Button
            appearance='text'
            variant='secondary'
            startIcon={<UploadFileOutlined fontSize='small' color='primary' />}
            className='mr-2 leading-[16px] text-primary'
            onClick={onSubmit}
          >
            Upload Another File
          </Button>
          <Button onClick={onClose}>Continue</Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddMoreFilesModal
